window.CloudImageHandler = {
  optimizeImageUrl: function(url) {
    if (!url) return url;
    let clean = url.toString().trim();
    if (clean.startsWith("//")) clean = "https:" + clean;

    if (this.isCloudImage(clean)) {
      if (!clean.includes('/card/') && !clean.includes('/thumb/')) {
        try {
          const urlParts = clean.split('/');
          const filename = urlParts.pop();
          const newFilename = filename.replace(/\.(jpg|jpeg|png)$/i, '.webp');
          clean = urlParts.join('/') + '/card/' + newFilename;
        } catch (e) {
          clean = clean.replace(/\.(jpg|jpeg|png)$/i, '.webp');
        }
      }
      return clean;
    }
    
    if (clean.includes("cdn.shopify.com") && clean.includes("/products/")) {
      return clean.replace(/_(pico|icon|thumb|small|compact|medium|large|grande|original|master|\d+x\d*)/g, "").replace(/\.(jpg|jpeg|png|gif|webp)/i, `_600x600.$1`);
    } else if (clean.includes("cdn.shopify.com") && clean.includes("/files/")) {
      return clean.replace(/_\d+x\d*(?=\.(jpg|jpeg|png|gif|webp))/i, "");
    } else {
      const stripped = clean.replace(/^https?:\/\//, "");
      return `https://wsrv.nl/?url=${encodeURIComponent(stripped)}&w=600&output=webp&q=80`;
    }
  },

  isCloudImage: function (url) {
    if (!url) return false;
    return url.indexOf('storage.googleapis.com') !== -1 || url.indexOf('discovery-ai-v3-public') !== -1;
  },

  onError: function (img, imagesBase64, handle = '', title = '') {
    try {
      const images = JSON.parse(atob(imagesBase64));
      const currentUrl = img.getAttribute('data-current-url') || img.src;

      let currentIndex = -1;
      for (let i = 0; i < images.length; i++) {
        const uri = images[i].url || images[i].uri || images[i].src;
        if (uri && (currentUrl.includes(uri) || uri.includes(currentUrl))) {
          currentIndex = i;
          break;
        }
      }

      // Layer 2: Retry with Proxy (wsrv.nl)
      if (!img.getAttribute('data-retried-proxy')) {
        console.log(`Vertex Search: Image failed, retrying with proxy: ${currentUrl}`);
        img.setAttribute('data-retried-proxy', 'true');
        const stripped = currentUrl.replace(/^https?:\/\//, "");
        img.src = `https://wsrv.nl/?url=${encodeURIComponent(stripped)}&w=600&output=webp&q=80`;
        return;
      }

      // Layer 3: Try next available image from Vertex data
      if (currentIndex !== -1 && currentIndex < images.length - 1) {
        const nextImage = images[currentIndex + 1];
        const nextUrl = nextImage.url || nextImage.uri || nextImage.src;
        console.log(`Vertex Search: Image failed after proxy retry, trying next (${currentIndex + 1}/${images.length}): ${nextUrl}`);
        img.setAttribute('data-current-url', nextUrl);
        img.removeAttribute('data-retried-proxy');

        let clean = nextUrl.toString().trim();
        if (clean.startsWith("//")) clean = "https:" + clean;
        if (this.isCloudImage(clean)) {
          if (!clean.includes('/card/') && !clean.includes('/thumb/')) {
            try {
              const urlParts = clean.split('/');
              const filename = urlParts.pop();
              const newFilename = filename.replace(/\.(jpg|jpeg|png)$/i, '.webp');
              clean = urlParts.join('/') + '/card/' + newFilename;
            } catch (e) {
              clean = clean.replace(/\.(jpg|jpeg|png)$/i, '.webp');
            }
          }
        } else if (clean.includes("cdn.shopify.com") && clean.includes("/products/")) {
          clean = clean.replace(/_(pico|icon|thumb|small|compact|medium|large|grande|original|master|\d+x\d*)/g, "").replace(/\.(jpg|jpeg|png|gif|webp)/i, `_600x600.$1`);
        } else if (clean.includes("cdn.shopify.com") && clean.includes("/files/")) {
          clean = clean.replace(/_\d+x\d*(?=\.(jpg|jpeg|png|gif|webp))/i, "");
        } else if (clean.includes("owimages.com") || (!clean.includes("cdn.shopify.com") && !clean.includes("storage.googleapis.com"))) {
          const stripped = clean.replace(/^https?:\/\//, "");
          clean = `https://wsrv.nl/?url=${encodeURIComponent(stripped)}&w=600&output=webp&q=80`;
        }
        img.src = clean;

        // SYNC WITH POTENTIAL VISUALIZER BUTTON (Future proofing)
        const rugCard = img.closest('.card') || img.closest('.card-wrapper');
        if (rugCard) {
          const btn = rugCard.querySelector('.see-in-room-btn');
          if (btn) {
            console.log(`Vertex Search: Syncing potential Visualizer button with next candidate: ${clean}`);
            btn.setAttribute('data-rug', clean.replace('&w=600', '&w=2048').replace('/card/', '/').replace('/thumb/', '/'));
          }
        }
        return;
      }

      // Layer 4: Active Discovery - Fetch freshest live image from Shopify database
      const brokenLoad = img.complete && img.naturalWidth === 0;
      if (!img.getAttribute('data-retried-discovery') || brokenLoad) {
        img.setAttribute('data-retried-discovery', 'true');
        this.recoverShopifyImage(img, handle, title);
        return;
      }

      // Final failure
      img.style.opacity = '0.3';
      img.onerror = null;
    } catch (e) {
      img.style.display = 'none';
    }
  },

  recoverShopifyImage: async function (img, handle = '', title = '') {
    try {
      console.log(`Vertex Search: Layer 4 - Pinging Shopify for live image for product: ${handle || title}`);
      let freshUrl = '';

      // Try handle-based fetch first
      if (handle) {
        const res = await fetch(`/products/${handle}.js`);
        if (res.ok) {
          const product = await res.json();
          if (product.images && product.images.length > 0) freshUrl = product.images[0];
        }
      }

      // Fallback to title search if handle fails or isn't available
      if (!freshUrl && title) {
        const res = await fetch(`/search/suggest.json?q=${encodeURIComponent(title)}&resources[type]=product`);
        if (res.ok) {
          const data = await res.json();
          const products = data.resources?.results?.products;
          if (products && products.length > 0) freshUrl = products[0].image;
        }
      }

      if (freshUrl) {
        console.log(`Vertex Search: Layer 4 Success - Found fresh URL: ${freshUrl}`);
        img.src = freshUrl;

        // SYNC WITH POTENTIAL VISUALIZER BUTTON
        const rugCard = img.closest('.card') || img.closest('.card-wrapper');
        if (rugCard) {
          const btn = rugCard.querySelector('.see-in-room-btn');
          if (btn) {
            console.log(`Vertex Search: Syncing potential Visualizer button with discovery URL: ${freshUrl}`);
            btn.setAttribute('data-rug', freshUrl);
          }
        }
        return;
      }
    } catch (e) {
      console.error("Discovery error:", e);
    }
    // Final failure state
    img.style.opacity = '0.3';
    img.onerror = null;
  }
};
